import moment from "moment-timezone";
import PropTypes from "prop-types";
import React from "react";
import MediaQuery from "react-responsive";
import {Link} from "react-router";

import {DATE_FORMAT_ISO} from "config/constants";
import {getDateFormat} from "utils";
import DatePicker from "v2/components/DatePicker";

const CalendarLink = (props, context) => {
  const {location: {pathname, query}, params: {date}, router} = context;
  const {className} = props;

  const label = moment(date).format(getDateFormat());
  const linkStyle = {
    boxShadow: "none",
  };
  const linkTo = {
    pathname: `/${date}/calendar`,
    query: {
      ...query,
      next: pathname,
    },
  };

  return (
    <div className={className}>
      <MediaQuery maxWidth={768}>
        <Link
          className="btn btn-link"
          style={linkStyle}
          to={linkTo}>
          {label} &rsaquo;
        </Link>
      </MediaQuery>
      <MediaQuery minWidth={768}>
        <DatePicker
          linkClassName="btn btn-link NoBoxShadow NoOutlineOnFocus"
          onDayClick={(evt, day) => {
            router.push({
              pathname: `/${moment(day).format(DATE_FORMAT_ISO)}`,
              query,
            });
          }}
          popover>
          {label}
          <span className="caret" style={{marginLeft: "5px"}} />
        </DatePicker>
      </MediaQuery>
    </div>
  );
};

CalendarLink.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};
CalendarLink.propTypes = {
  className: PropTypes.string,
};

export default CalendarLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/CalendarLink.js
 **/